import React from 'react';
import "./header.css"
const Header = () => {
    return (
        <header className="heading">
            <h1 className="heading__title">TODO List</h1>
            <p className="heading__subtitle">Stay organized and productive</p>
        </header>
    );
};

export default Header;
